var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.pageTitle } },
    [
      _c(
        "template",
        { slot: "primaryActions" },
        [
          _c("app-button", {
            attrs: {
              text: _vm.$t("common.bck"),
              icon: "fa-light fa-arrow-left",
              variant: "primary",
            },
            on: { click: _vm.goBack },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c("ca-form-global", {
                attrs: {
                  mode: _vm.mode,
                  id: _vm.id,
                  readonly: !_vm.isEditable,
                },
                on: { bottomActions: _vm.handleBottomActions },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("template", { slot: "bottomActions" }, [
        _vm.bottomActionsData.show
          ? _c(
              "div",
              {
                staticClass: "d-flex justify-content-end flex-wrap",
                staticStyle: { gap: "0.75rem" },
              },
              _vm._l(_vm.bottomActionsData.actions, function (action, index) {
                return _c(
                  action.component,
                  _vm._b(
                    {
                      key: index,
                      tag: "component",
                      on: { click: action.handler },
                    },
                    "component",
                    action.props,
                    false
                  )
                )
              }),
              1
            )
          : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }